import React, { useState, useEffect } from "react";
import TrainerFilter from "./trainer";
import { startLoader, stopLoader } from "../../../lib/utils";
import { getAllParameters } from "../../../features/parameters/helper/api";
import { isAuthenticated } from "../../../auth";

const ExpenseFilter = (props) => {

  const {user,token} = isAuthenticated();
  const [currentElementId, setCurrentElementId] = useState("");
  const [isExpenseTypeListOpen, setExpenseTypeListOpen] = useState(false);
  const [expenseTypes, setExpenseTypes] = useState([]);
  const [expense,setExpense] = useState({
    expenseType:"",
    expenseAmount:"",
    recipientUser: "",
    paidTo:{
      companyName:"",
      companyDesignation: ""
    }
  });
  const {expenseAmount,expenseType,paidTo,recipientUser} = expense;
    

  const GetAllParameters = async () =>{
    try{
      let params = {
        noLimit: 'noLimit',
        sortByInstafit: "sort",
        type:"expenseType"
      }

      let response = await getAllParameters(user._id,token,params);

      if(!response.error){
        setExpenseTypes(response);
      }
    }catch(error){
      //
    }
  }

  
  const getRecipient = data =>{
    setExpense(oldstate=>{
      oldstate['recipientUser'] = data;
      return {...oldstate};
    })
  }


  const toggleInputFields = (id) => event => {
    setCurrentElementId(id);
    if (id == 'expense-type') setExpenseTypeListOpen(!isExpenseTypeListOpen);
    if (event) {
      let interval = setInterval(() => {
        let element = event.target.querySelector('input');
        if (element) {
            element.focus();
            clearInterval(interval)
        }
      }, 0);
    }
  }

  const handleChange = keyName => event => {
    setExpense(oldState=>{
      if(keyName.includes(".")){
        oldState[keyName.split('.')[0]][keyName.split('.')[1]]=event.target.value;
      }else{
        oldState[keyName] = event.target.value;
      }
      return {...oldState};
    })
  }

  const handleSelectExpenseType = data => event => {
    setExpense({
      ...expense,
      expenseType:data.name
    })
  }

  const handlePaidToChange = keyName => event =>{
    setExpense(oldtstate=>{
      oldtstate.paidTo[keyName] = event.target.value;
      return {...oldtstate};
    })
  }


  useEffect(async ()=>{
    try{
    await startLoader()
    await GetAllParameters();
    await stopLoader()
    }catch(error){

    }
  },[])


  return(
    <div className="w-full m-b-20">  
      <p className="flex-item fs-16 font-weight-700 m-b-6">Expense Filter</p>
      <div className="d-flex w-full space-between m-b-12">

        <div onClick={toggleInputFields('expense-amount')} className={`${(currentElementId == 'expense-amount' || expenseAmount) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'expense-amount' || expenseAmount) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
          <div className="flex-item d-flex">
            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'expense-amount' || expenseAmount) ? "10px" : "14px", color: (currentElementId == 'expense-amount' || expenseAmount) ? "var(--darkBlue)" : "", transition: "180ms" }}>Amount</p>
          </div>
          <input value={expenseAmount} onChange={handleChange("expenseAmount")} style={{color: expenseAmount ? "#5d883c" : expenseAmount ? "#ef4035" : "#2b2b2b"}} className={`${(currentElementId == 'expense-amount' || expenseAmount) ? "active-input-field" : "inactive-input-field"}`} type="number" />
        </div>

        <div onClick={toggleInputFields('expense-type')} className={`${(currentElementId == "expense-type" || expenseType) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == "expense-type" || expenseType) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
          <div className="flex-item d-flex">
            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "expense-type" || expenseType) ? "10px" : "14px", color: (currentElementId == "expense-type" || expenseType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Expense Type</p>
          </div>
          <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
            <svg className="flex-item" style={{ transform: isExpenseTypeListOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
            </svg>
          </div>
          <input id="expense-type" className={`${(currentElementId == "expense-type" || expenseType) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select" value={expenseType} style={{ pointerEvents: "none", textTransform: 'capitalize' }} disabled/>
          {
            isExpenseTypeListOpen && (
              <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                {
                  expenseTypes.map(data=>{
                    return (
                      <div onClick={handleSelectExpenseType(data)} className="global-input-field-arrow-dropdown-item">
                        <p className="flex-item" style={{textTransform:'capitalize'}}>{data.name}</p>
                      </div>
                    );
                  })
                }
              </div>
            )
          }
        </div>              
      </div>

      
      {
        expenseType == "Salaries & Wages" ? (
          <TrainerFilter getRecipient={getRecipient} selectedGym={props.selectedGym} />
        ) : (
          <div className="d-flex space-between">
            <div onClick={toggleInputFields('company-name')} className={`${(currentElementId == 'company-name' || paidTo.companyName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'company-name' || paidTo.companyName) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
              <div className="flex-item d-flex">
                <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'company-name' || paidTo.companyName) ? "10px" : "14px", color: (currentElementId == 'company-name' || paidTo.companyName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Company Name</p>
              </div>
              <input value={paidTo.companyName} onChange={handlePaidToChange("companyName")} style={{color: paidTo.companyName ? "#5d883c" : paidTo.companyName ? "#ef4035" : "#2b2b2b"}} className={`${(currentElementId == 'company-name' || paidTo.companyName) ? "active-input-field" : "inactive-input-field"}`} type="text" />
            </div>

            <div onClick={toggleInputFields('company-designation')} className={`${(currentElementId == 'company-designation' || paidTo.companyDesignation) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'company-designation' || paidTo.companyDesignation) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
              <div className="flex-item d-flex">
                <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'company-designation' || paidTo.companyDesignation) ? "10px" : "14px", color: (currentElementId == 'company-designation' || paidTo.companyDesignation) ? "var(--darkBlue)" : "", transition: "180ms" }}>Designation</p>
              </div>
              <input value={paidTo.companyDesignation} onChange={handlePaidToChange("companyDesignation")} style={{color: paidTo.companyDesignation ? "#5d883c" : paidTo.companyDesignation ? "#ef4035" : "#2b2b2b"}} className={`${(currentElementId == 'company-designation' || paidTo.companyDesignation) ? "active-input-field" : "inactive-input-field"}`} type="text" />
            </div>
          </div>
        )
      }
    </div>
  )
}

export default ExpenseFilter;